'use client';

import { CheckIcon } from '@heroicons/react/16/solid';

// Interface
// ******************************************
interface BundleBenefitsProps {
  benefits?: ApiSchema<'BenefitItem'>[],
  iconColor?: string,
  className?: string,
}


/**
 * @description Renders the list of benefits in job-bundle card. Renders nothing if there are no benefits.
 * @param props
 */
export const BundleBenefits = (props: BundleBenefitsProps) => {
  // Props destructuring
  const {
    benefits,
    iconColor = 'text-secondary',
    className = '',
  } = props;

  const iconClasses = `w-5 h-5 ${iconColor} shrink-0`;

  // Temporary remove 'Multi-promo' from benefits
  const filteredBenefits = benefits?.filter((benefit) => benefit?.title !== 'Multi-promo');

  // Return null if there are no benefits
  // ******************************************
  if (!benefits || !benefits?.length) return null;


  // Render component
  // ******************************************
  return (
    <ul className={`flex flex-col ${className}`}>
      {
        // Sort highlighted benefits to appear first
        filteredBenefits
          ?.slice() // create a shallow copy so original array isn’t mutated
          .sort((a, b) => (b.highLighted ? 1 : 0) - (a.highLighted ? 1 : 0)) // highlighted first
          .map((benefit) => (
            <li key={benefit.title} className="flex gap-2 py-1 text-sm leading-tight">
              <CheckIcon className={iconClasses} />
              <span className={benefit.highLighted ? 'font-bold' : ''}>
                {benefit.title}
              </span>
            </li>
          ))
      }

    </ul>
  );
};

